import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogHelper, ExceptionHelper } from './../../../helper';

import { ChangePasswordService } from './change-password.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  password: FormControl;
  confirmPassword: FormControl;

  constructor(
    private changePasswordService: ChangePasswordService,
    private formBuilder: FormBuilder,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    translate.setDefaultLang('en-us');
  }

  ngOnInit() {
    this.createFormControls();
    this.createChangePasswordForm();
  }

  public createFormControls(): void {
    this.password = new FormControl('', [
      Validators.required,
      Validators.minLength(6)
    ]),
    this.confirmPassword = new FormControl('', [
      Validators.required
    ]);
  }

  public createChangePasswordForm(): void {
    this.changePasswordForm = this.formBuilder.group({
      password: this.password,
      confirmPassword: this.confirmPassword
    }, {
      validator: this.verifyConfirmPassword(this.password, this.confirmPassword)
    });
  }

  public changePassword(changePasswordForm): void {
    this.changePasswordService.changePassword(changePasswordForm.controls).subscribe(
      data  => {
          this.dialog.showModal('showSucModalBtn');
      },
      error => {
        this.exception.showError(error, 'showDanModalBtn');
      }
    );

  }

  public verifyConfirmPassword(passwordControl: FormControl, confirmPasswordControl: FormControl): any {
    return (group: FormGroup) => {
      if (passwordControl.value !== confirmPasswordControl.value) {
        return confirmPasswordControl.setErrors({mismatch: true});
      } else {
        return confirmPasswordControl.setErrors(null);
      }
    };
  }

  public closeSuccessModel(): void {
    this.router.navigate(['/home/my-profile']);
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/change-password/change-password.component.ts